import { useEffect as u } from "react";
import { a as f } from "../../../helpers-CNa1KUVl.mjs";
import { useWizardContext as n } from "../context/context.js";
function l(i, t) {
  const { delayedLoadingMs: r, dispatch: e, currentStepId: a } = n();
  u(() => {
    if (r !== 0) {
      e({
        type: "STEP_TRANSITION",
        loading: !0
      });
      const s = setTimeout(() => {
        e({
          type: "STEP_TRANSITION",
          loading: !1
        }), t && t();
      }, r);
      return f(i), function() {
        clearTimeout(s);
      };
    } else
      t && t();
    return () => {
    };
  }, [r, e, i, a, t]);
}
export {
  l as default
};
